import React from 'react';
import { useTranslation } from 'react-i18next';
import { currencyNumber } from '../utilities';

export const shortSiteId = site => {
  let id = '';
  switch (site) {
    case '24MX': {
      id = '24MX';
      break;
    }
    case 'CAPA': {
      id = 'COA';
      break;
    }
    case 'DVPE': {
      id = 'ADV';
      break;
    }
    case 'ICBR': {
      id = 'IC';
      break;
    }
    case 'IWBR': {
      id = 'IW';
      break;
    }
    case 'LLVE': {
      id = 'CLL';
      break;
    }
    case 'PLEC': {
      id = 'PLV';
      break;
    }
    case 'UBPE': {
      id = 'URB';
      break;
    }
    case 'WIBR': {
      id = 'WI';
      break;
    }
    case 'ZPAR': {
      id = 'ZP';
      break;
    }
    case 'VAMX': {
      id = 'VAMX';
      break;
    }
    default: {
      id = 'ZP';
    }
  }

  return id;
};
export const getPrices = (data, label) => {
  return {
    firstPrice: currencyNumber(data.posting.prices[0].currency, data.posting.prices[0].amount),
    expenses: data.posting.expenses && `+ ${currencyNumber('$', parseFloat(data.posting.expenses))}`,
    expensesLabel: label
  };
};

export const getLocations = data => {
  return {
    location:
      data.posting.location &&
      `${data.posting.location && data.posting.location.name}, ${data.posting.location.parent &&
        data.posting.location.parent.name} `,
    address: data.posting.address && `${data.posting.address} `
  };
};

export const getPictures = data => {
  return data.posting.pictures['360x266'].map(url => {
    return <img src={url} alt='' key={url} />;
  });
};

export const getFeaturesTranslations = t => {
  return {
    ROOMS_ICON: t('panel.postingcard.features.rooms'),
    ROOM_ICON: t('panel.postingcard.features.room'),
    BATHS_ICON: t('panel.postingcard.features.bathrooms'),
    BATH_ICON: t('panel.postingcard.features.bathroom'),
    GARAGES_ICON: t('panel.postingcard.features.garages'),
    GARAGE_ICON: t('panel.postingcard.features.garage'),
    STOTAL_ICON: t('panel.postingcard.features.icon.stotal'),
    TOTAL_ICON: t('panel.postingcard.features.icon.total'),
    BANOS: 'banos',
    HAB: 'habitaciones',
    COCHERA: 'cochera',
    GARAGE: 'garage',
    SUP_TOTAL: 'Superficie Total'
  };
};

export const getReviewPostingCardFeatures = (features, t) => {
  const transformedFeatures = [];
  const FEATURES_TRANSLATIONS = getFeaturesTranslations(t);

  features.forEach(item => {
    // eslint-disable-next-line default-case
    switch (item.icon) {
      case FEATURES_TRANSLATIONS.BANOS:
        item.icon = item.label > 1 ? FEATURES_TRANSLATIONS.BATHS_ICON : FEATURES_TRANSLATIONS.BATH_ICON;
        break;
      case FEATURES_TRANSLATIONS.HAB:
        item.icon = item.label > 1 ? FEATURES_TRANSLATIONS.ROOMS_ICON : FEATURES_TRANSLATIONS.ROOM_ICON;
        break;
      case FEATURES_TRANSLATIONS.COCHERA:
        item.icon = item.label > 1 ? FEATURES_TRANSLATIONS.GARAGES_ICON : FEATURES_TRANSLATIONS.GARAGE_ICON;
        break;
    }
    if (
      [
        FEATURES_TRANSLATIONS.STOTAL_ICON,
        FEATURES_TRANSLATIONS.ROOMS_ICON,
        FEATURES_TRANSLATIONS.ROOM_ICON,
        FEATURES_TRANSLATIONS.HAB,
        FEATURES_TRANSLATIONS.BATHS_ICON,
        FEATURES_TRANSLATIONS.BATH_ICON,
        FEATURES_TRANSLATIONS.GARAGES_ICON,
        FEATURES_TRANSLATIONS.GARAGE_ICON,
        FEATURES_TRANSLATIONS.COCHERA
      ].includes(item.icon)
    ) {
      transformedFeatures.push({
        label: `${item.label} ${item.icon !== FEATURES_TRANSLATIONS.STOTAL_ICON ? item.icon : ''}`
      });
    }
  });

  return transformedFeatures;
};
